import { render } from "./Donate.vue?vue&type=template&id=5d58ef90"
import script from "./Donate.vue?vue&type=script&lang=js"
export * from "./Donate.vue?vue&type=script&lang=js"

import "./Donate.vue?vue&type=style&index=0&id=5d58ef90&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__